








import Vue from 'vue';
import store from '@/store';

import AdaptiveChartsLayout from '@/components/utils/AdaptiveChartsLayout.vue';

export default Vue.extend({
  components: {
    AdaptiveChartsLayout
  },

  props: {
    userId: Number
  },

  computed: {
    organizationId(): number {
      return store.state.org.basic.organizationId;
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    userProfileComponent(): any {
      return {
        component: 'organization-user-profile',
        props: {
          userId: this.userId
        },
        tabName: 'Memberships & Roles'
      };
    }
  }
});
